let chkPasswd = (rule, value, callback) => {
	let regExp = /^[0-9a-zA-Z_]{6,16}$/;
	if (!regExp.test(value)) {
		return callback(new Error('密码由6-16个数字大小写字母和下划线组成'));
	}
	return callback();
}
let chkMobile = (rule, value, callback) => {
	if (value) {
		let regExp = /^1[0-9]{10}$/;
		if (!regExp.test(value)) {
			return callback(new Error('手机格式错误'));
		}
	}
	return callback();
}
let chkEmail = (rule, value, callback) => {
	if (value) {
		let regExp = /^[a-zA-Z0-9]{2,20}@[a-z0-9]{2,10}\.(com|cn|net|org)$/;
		if (!regExp.test(value)) {
			return callback(new Error('邮箱格式错误'));
		}
	}
	return callback();
}
let chkPrice = (rule, value, callback) => {
	if (value) {
		let regExp = /^[1-9]\d*$/;
		if (!regExp.test(value)) {
			return callback(new Error('只能是正整数'));
		}
	}
	return callback();
}
let chkWeight = (rule, value, callback) => {
	if (value) {
		let regExp = /^((0{1}\.\d{1,2})|([1-9]\d*\.{1}\d{1,2})|([1-9]+\d*))$/;
		if (!regExp.test(value)) {
			return callback(new Error('只能是正数（小数保留两位）'));
		}
	}
	return callback();
}
export{
	chkPasswd,	//密码判断
	chkMobile,	//手机判断
	chkEmail,	//邮箱判断
	chkPrice,	//正整数的正则表达式(不包括0)
	chkWeight,	//正数的正则表达式(不包括0，小数保留两位)
}
